import React from "react";

import RadioButtonSvg from "../../assets/images/icons/Radio/off.svg";

export const RadioOffIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={RadioButtonSvg}
        alt={alt || "Radio"}
    />
);
